import { Table } from 'antd';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { IconEdit, IconRecipe } from '../../../../../assets/index';
import { routes } from '../../../../../utils/constants/constant';
import { formatMoney, isEmpty } from '../../../../../utils/helpers/helpers';
import FilterDialogMobile from './FilterDialogMobile/FilterDialogMobile';
import './ListCampaign.scss';

const ListCampaign = (props) => {
  const { listCampaign, fetListCampaign } = props;
  const history = useHistory();
  const { filterType, onChangeDate, filterDate, onChange } = props;
  const columns = [
    {
      title: () => {
        return <div style={{}}>CID</div>;
      },
      // title: 'CID',
      dataIndex: 'id',
      key: 'id',
      align: 'center',
      width: '50px',
    },
    {
      title: 'Chiến dịch',
      dataIndex: 'name',
      key: 'name',
      // align: 'center',
      width: 150,
    },
    {
      title: 'Loại Quảng cáo',
      dataIndex: 'type',
      key: 'type',
      // align: 'center',
      width: '120px',
    },
    {
      title: 'Lượt xem',
      dataIndex: 'numVisitors',
      key: 'numVisitors',
      // align: 'center',
      width: 100,
    },
    {
      title: 'Tỉ lệ chuyển đổi đơn hàng',
      key: 'conversionRate',
      render: (tags, record) => <>{record.conversionRate}%</>,
      // align: 'center',
      width: '150px',
    },
    {
      title: 'Đơn hàng đã đặt',
      key: 'numBookings',
      dataIndex: 'numBookings',
      // align: 'center',
      width: '120px',
    },
    {
      title: 'Tổng doanh số',
      key: 'totalAmount',
      dataIndex: 'totalAmount',
      render: (totalAmount) => <>{`${formatMoney(totalAmount)} VNĐ`}</>,
      // align: 'center',
      width: '120px',
    },
    {
      title: '',
      key: 'action',
      render: (text, record) => {
        return (
          <div
            style={{ cursor: 'pointer' }}
            onClick={() => {
              if (record.type === 'link') {
                history.push(
                  `${routes.DASHBOARD_TEXT_LINK}?aff_cid=${record.id}`
                );
              } else if (record.type === 'banner') {
                history.push(`${routes.DASHBOARD_BANNER}?aff_cid=${record.id}`);
              }
            }}
          >
            <IconEdit />
          </div>
        );
      },
    },
  ];

  return (
    <div className='list-campaign'>
      <FilterDialogMobile
        filterType={filterType}
        onChangeDate={onChangeDate}
        filterDate={filterDate}
        onChange={onChange}
        fetListCampaign={fetListCampaign}
      />
      {/* {isEmpty(listCampaign) ? (
        <div className='empty-qc'>
          <IconRecipe />
          <span style={{ paddingTop: 10 }}>Chưa có danh sách quảng cáo</span>
        </div>
      ) : ( */}
      {isEmpty(listCampaign) ? (
        <div className='empty-qc'>
          <IconRecipe />
          <span style={{ paddingTop: 10 }}>Chưa có danh sách quảng cáo</span>
        </div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <Table
            columns={columns}
            dataSource={listCampaign}
            size='medium'
            // pagination={false}
          />
        </div>
      )}
      {/* )} */}
    </div>
  );
};

export default ListCampaign;
